import { render, staticRenderFns } from "./AdminBauprojekt.vue?vue&type=template&id=36585084&scoped=true&"
import script from "./AdminBauprojekt.vue?vue&type=script&lang=js&"
export * from "./AdminBauprojekt.vue?vue&type=script&lang=js&"
import style0 from "./AdminBauprojekt.vue?vue&type=style&index=0&id=36585084&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36585084",
  null
  
)

export default component.exports